import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Router} from '@angular/router';

@Component({
  templateUrl: './action-completion-dialog.component.html'
})
export class ActionCompletionDialogComponent implements OnInit {
  public buttonText: string;
  private readonly redirectURL: string;

  constructor(private matDialogRef: MatDialogRef<ActionCompletionDialogComponent>,
              private router: Router,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.buttonText = this.data.buttonText;
    this.redirectURL = this.data.redirectURL;
  }

  public ngOnInit(): void {
    this.matDialogRef.updateSize('600px');
    this.matDialogRef.disableClose = true;
  }

  public continueAction(): void {
    this.matDialogRef.close();
    const route = this.router.url;
    this.router.navigated = false;
    this.router.navigate([route]);
  }

  public navigateAction(): void {
    this.matDialogRef.close();
    if (this.redirectURL.includes('tab')) {
      this.router.navigate(
        ['purchase_order_requests'],
        {
          queryParams: { tab: 'accessories' }
        }
      );
    } else {
      this.router.navigate([this.redirectURL]);
    }

  }
}
